import { required, helpers, sameAs } from 'vuelidate/lib/validators';
import {StoreProxy} from "@/api/common/StoreProxy";
import {UserManagement} from "@/api/modules/userManagement/UserManagement";
import {AccountSearch} from "@/views/apps/Users/Common/AccountSearch";
import {User} from "@/api/modules/userManagement/models/User";
import CreateDealer from "@/components/createDealer/CreateDealer.vue"
import _ from "lodash";

export default {
    name: "AddUser",
    _service: null,

    data() {
        return {
            usernameTaken: false,
            isAccountLoading: false,
            availableRoles: [],
            checkedRoles: [],
            isCreateDealerDialogVisible: false,
            form: {
                account: '',
                username: '',
                firstName: '',
                lastName: '',
                email: '',
                userPassword: '',
                verifyPassword: '',
                error: false
            },
        }
    },
    validations : {
            form: {
                username: { required },
                firstName: { required },
                lastName: {required},
                email: { required },
                userPassword: {
                    required
                },
                verifyPassword: {
                    required,
                    sameAsPassword : sameAs('userPassword')
                }
            }
        },
    components: {
        CreateDealer: CreateDealer
    },
    created(){
       this._userManagement = new UserManagement(StoreProxy.getAuth(this.$store));
       this._accountSearch = new AccountSearch(StoreProxy.getAuth(this.$store));

       let vm = this;
        this._userManagement.getRoles().then(roles => {
            vm.availableRoles = roles;
        }).catch(e => {

            vm.availableRoles = [];

            this.$notify.error({
                title: `Roles`,
                message: 'Error loading defined roles'
            });

        });
    },
    mounted() {

    },
    methods: {
        activatePassword(){
            this.$refs.password.readonly = false;
            this.$refs.verifyPassword.readonly = false;
        },
        checkValidation(obj) {
            obj.$touch();
        },
        checkUsername(username){

           if ((!username) || username.length == 0)return;

           let vm = this;
           this._userManagement.checkUsername(username).then(result => {
              if (result){
                  vm.usernameTaken = false;
              }
              else {
                  vm.usernameTaken = true;
              }

           }).catch(e => {

               this.$notify.error({
                   title: 'Internal Error',
                   message: 'Error when checking the username availability'
               });

           });


        },

        onCancel(){
          this.$router.back();
        },
        onSubmit() {
            this.$v.$touch();

            if (this.$v.$invalid){
                this.form.error = true;
                window.tracer.debug("[d391786-ADM] Form Error - Missing required fields");
            }
            else{
                this.form.error = false;
                if (!this.$v.$invalid)  {


                    let user = new User();

                    if (this.form.account.length > 0){
                        user.account = this.form.account;
                    }

                    user.userName = this.form.username;
                    user.firstName = this.form.firstName;
                    user.lastName = this.form.lastName;
                    user.email = this.form.email;

                    let vm = this;

                    this._userManagement.createUser(user, vm.form.userPassword).then( id => {

                        vm.addRoles(id).then(() =>{
                            this.$message({
                                message: `User ${user.firstName} ${user.lastName} successfully created`,
                                type: 'success'
                            });

                            this.$router.push("/dashboard");
                        }).catch(e => {
                            this.$notify.error({
                                title: 'Role(s) Error',
                                message: `Failed register role(s) to newly created user.`
                            });
                        });

                    }).catch(e => {

                        this.$notify.error({
                            title: 'Create User Error',
                            message: `User ${user.firstName} ${user.lastName} not created`
                        });
                    });

                }

            }
        },
        accountSearch(searchString, cb) {

            try {
                this.isAccountLoading = true;
                this._accountSearch.search(searchString).then(roles => {
                    cb(roles);
                    this.isAccountLoading = false
                }).catch(e => {
                    window.tracer.error(e);
                })
            } catch (e) {
                window.tracer.error(e);
            } finally {
                this.isAccountLoading = false;
            }

        },
        onSelectedAccount(item){
          this.form.account = item;
        },
        /**
         * Adds selected roles to the user
         * @param userId
         * @returns {Promise<()>}
         */
        addRoles(userId){
            return new Promise((resolve, reject) => {
                try{

                    let vm = this;
                    let success = true;

                    if (vm.checkedRoles.length == 0){
                        resolve();
                        return;
                        // none roles checked; just exist with a success hint.
                    }

                    this.availableRoles.forEach(function(r) {

                        let isChecked = _.findIndex(vm.checkedRoles, function(o){
                            return o == r.name;
                        }) != -1;


                        if (isChecked) {
                            window.tracer.debug(`[d353675-ADM] Add ${r.name} role for user ${userId}`);
                            // does not exists in the retrieved roles, but exists in the checked roles, therefore add the role
                            vm._userManagement.addRole(userId, r.name).then(() => {
                                    window.tracer.debug(`[d492706-ADM] role ${r.name} added to user ${userId}`);
                                }
                            ).catch(e => {
                                success = false;
                                window.tracer.error(e);
                                reject(e);
                            })

                        }
                    });

                    if (success){
                        resolve();
                    }
                    else{
                        reject();
                    }

                }
                catch(e){

                    window.tracer.error(e);
                    window.tracer.error("[e147049-ADM] Failure adding/removing roles");
                    reject(e);

                }

            });
        },
        openNewDealerDialog(){
            this.isCreateDealerDialogVisible = true;

            window.tracer.verbose(`[v117191] Dealer dialog opened`);
        },
        closeCreateDealerDialog(){
            this.isCreateDealerDialogVisible = false;

            window.tracer.verbose(`[v598815] Dealer dialog closed`);
        },
        onDealerCancelled(){
            this.isCreateDealerDialogVisible = false;

            window.tracer.verbose(`[v318776] Dealer dialog cancelled event triggered.`);
        },
        onDealerSaved(account){
            this.form.account = account;
            this.isCreateDealerDialogVisible = false;

            window.tracer.verbose(`[v222449] Dealer 'saved' event triggered with account: '${account}' as argument`);

        },
        onDealerSaveFailed(){
            this.form.account = '';
        }
    }
}